import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "buyTicketBanner" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "preview" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "h3" }
const _hoisted_7 = ["href", "aria-label"]


export default /*@__PURE__*/_defineComponent({
  __name: 'BuyTicketBanner',
  props: {
    title: {},
    imageSrc: {},
    imageAlt: {},
    link: {},
    linkText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.imageSrc,
          loading: "lazy",
          class: "backgroundImage",
          alt: _ctx.imageAlt
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1),
        _createElementVNode("a", {
          href: _ctx.link,
          "aria-label": `${_ctx.title} ${_ctx.linkText}`,
          class: "button"
        }, _toDisplayString(_ctx.linkText), 9, _hoisted_7)
      ])
    ])
  ]))
}
}

})